import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TravelSplash from "./TravelSplash";

// Icon Animation on Hover
const HoverGifIcon = ({ staticSrc, gifSrc, alt, active }) => {
  return (
    <img
      src={active ? gifSrc : staticSrc}
      alt={alt}
      style={{
        width: 42,
        height: 42,
        objectFit: "contain",
        transform: active ? "scale(1)" : "scale(1)",
        transition: "transform 0.15s ease-out",
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
      }}
    />
  );
};

function LandingPage() {
  const [searchParams] = useSearchParams();
  const showSplashInitially = searchParams.get("splash") === "true";

  const [showSplash, setShowSplash] = useState(showSplashInitially);
  const [hoveredKey, setHoveredKey] = useState(null);

  const navigate = useNavigate();
  const loggedUser = JSON.parse(localStorage.getItem("CapacitorStorage.user"));
  const user_id = loggedUser.id;
  const user_mobile = loggedUser.mobile;
  const store_id = loggedUser.store_id;
  const userDataObject = {
    user_id,
    user_mobile,
    store_id,
  };

  const pageRoutes = [
    {
      label: "Dashboard",
      screenRoute: "/travel/dashboard",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/travel-dashboard.png")}
          gifSrc={require("../../assets/icons/travel-dashboard.gif")}
          active={hovered}
        />
      ),
      key: "dashboard",
    },
    {
      label: "Bookings",
      screenRoute: "/travel/booking",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/booking-master.png")}
          gifSrc={require("../../assets/icons/booking-master.gif")}
          active={hovered}
        />
      ),
      key: "bookings",
    },
    {
      label: "Customer Master",
      screenRoute: "/travel/customer-master",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/customer-master.png")}
          gifSrc={require("../../assets/icons/customer-master.gif")}
          active={hovered}
        />
      ),
      key: "customerMaster",
    },
    {
      label: "Driver Master",
      screenRoute: "/travel/driver-master",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/driver-master.png")}
          gifSrc={require("../../assets/icons/driver-master.gif")}
          active={hovered}
        />
      ),
      key: "driverMaster",
    },
    {
      label: "Vehicle Master",
      screenRoute: "/travel/vehicle-master",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/vehicle-master.png")}
          gifSrc={require("../../assets/icons/vehicle-master.gif")}
          active={hovered}
        />
      ),
      key: "vehicleMaster",
    },
  ];

  return (
    <>
      {/* SPLASH OVERLAY */}
      {showSplash && <TravelSplash onFinish={() => setShowSplash(false)} />}

      {/* MAIN CONTENT */}
      {!showSplash && (
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            animation: "fadeIn 0.4s ease",
          }}
        >
          <Box sx={{ display: "flex", gap: 6 }}>
            {/* {pageRoutes.map((page) => {
              const isHovered = hoveredKey === page.key;

              return (
                <Box
                  key={page.key}
                  onMouseEnter={() => setHoveredKey(page.key)}
                  onMouseLeave={() => setHoveredKey(null)}
                  onClick={() =>
                    navigate(page.screenRoute, { state: userDataObject })
                  }
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    transform: isHovered ? "scale(1.08)" : "scale(1)",
                    transition: "transform 0.2s ease",
                  }}
                >
                  <Box
                    sx={{
                      width: 96,
                      height: 96,
                      borderRadius: 2,
                      bgcolor: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: isHovered
                        ? "0px 8px 20px rgba(0,0,0,0.15)"
                        : "0px 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    {page.icon(isHovered)}
                  </Box>

                  <Typography sx={{ mt: 1, fontWeight: 600 }}>
                    {page.label}
                  </Typography>
                </Box>
              );
            })} */}
            {pageRoutes.map((page) => {
              const isHovered = hoveredKey === page.key;

              return (
                <Box
                  key={page.key}
                  onMouseEnter={() => setHoveredKey(page.key)}
                  onMouseLeave={() => setHoveredKey(null)}
                  onClick={() =>
                    navigate(page.screenRoute, { state: userDataObject })
                  }
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    p: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 96,
                      height: 96,
                      borderRadius: 2,
                      bgcolor: "#F5F5F5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {page.icon(isHovered)}
                  </Box>

                  <Typography
                    sx={{
                      mt: 1,
                      fontWeight: 600,
                      transform: isHovered ? "scale(0.9)" : "scale(1)",
                      transition: "transform 0.2s ease",
                    }}
                  >
                    {page.label}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </>
  );
}

export default LandingPage;
